// extracted by mini-css-extract-plugin
module.exports = {"root":"PendingPaymentAlert_root__18acX","buttons":"PendingPaymentAlert_buttons__20Hw8"};